import { render } from "./BuilderSection.vue?vue&type=template&id=db10f136"
import script from "./BuilderSection.vue?vue&type=script&lang=js"
export * from "./BuilderSection.vue?vue&type=script&lang=js"

import "./BuilderSection.vue?vue&type=style&index=0&id=db10f136&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__